'use strict'

import React from 'react'

/**
 * 削除確認モーダルの説明文（通常 / 使用中）
 *
 * @param {{ hasUsedStatus: boolean; periodNamesText: string }} params
 * @returns {React.ReactElement | string}
 */
export function buildDeleteConfirmDescription({ hasUsedStatus, periodNamesText }) {
  if (!hasUsedStatus) {
    return <div className="text-center">この判定ルールを削除しますか？</div>
  }

  return (
    <React.Fragment>
      <div className="text-center">この判定ルールを削除しますか？</div>
      <div className="pt-5 text-center red--text">
        このルールは使用中のルールです。
        <br />
        削除後は再度マッピングの設定を確認してください。
      </div>
      <div className="pt-5 text-center">
        以下の期間で使用されています。
        {periodNamesText ? (
          <>
            <br />
            <span className="font-bold">{periodNamesText}</span>
          </>
        ) : null}
      </div>
    </React.Fragment>
  )
}
